import { Container,Text,Button } from "@chakra-ui/react"
import { useDisclosure } from "@chakra-ui/react"
import { ConnectWallet } from "../../utility/metamaskModal/connectWalletModal"

const Dashboard = ()=>{
    const {isOpen,onClose,onOpen} = useDisclosure()
    return(
        <Container>
            <Text>Modal</Text>
            <Button onClick={onOpen}>
                Open Modal
            </Button>
            {ConnectWallet({isOpen,onOpen,onClose})}
        </Container>
    )
}

export default Dashboard